const state = {
  /**
   * 直播状态
   * start 未开始
   * progress 进行中
   * end 已结束
   * 
   * 直播状态会变化的两种情况：
   * 
   * 1. 一次性更新 用户第一次进页面 通过 live_start_at live_end_at 来判断直播状态
   * start 未开始：live_start_at 为null
   * progress 进行中：live_start_at 有值，live_end_at 为null
   * end 已结束：live_end_at 有值
   * 
   * 2. 事实监听更新 SDK回调
   * progress 进行中：user-published
   * end 已结束：user-unpublished
   */
  liveStatus: '',
  /**
   * 直播状态的信息
   * 主播并未点击关闭直播却离开了频道：主讲人暂时离开了直播间，稍候回来（liveStatus：end）
   */
  liveStatusReason: null,
  // AgoraRTCClient 对象
  client: null,
  // 直播 token（主播 token）
  token: null,
  // 当前 音频轨道
  localAudioTrack: null,
  // 当前 视频轨道
  localVideoTrack: null,
  // 直播的音视频轨道
  rtc: {
    audioDeviceId: null, // 当前 音频设备 id
    videoDeviceId: null, // 当前 视频设备 id
    audioDeviceArr: [], // 可选 音频设备集合
    videoDeviceArr: [] // 可选 视频设备集合
  },
  // 直播的一些设置
  options: {
    appId: null, // 直播 App ID
    channel: null, // 直播频道名
    // token: null, // 直播 token（主播 token）
    role: 'audience', // 设置用户为 host (可发流) 或 audience（仅可收流）
    level: 1, // 观众延时级别 1: 低延时 2: （默认）超低延时
    uid: null // 用户 accountToken
  },
  // 直播详情基本信息
  liveDetailData:{
    token: '', //直播token
    title: '', //直播标题
    desc: '', //直播描述
    company_info: null, //公司信息
    start_at: '', //直播开始时间		
    end_at: '', //直播结束时间		
    channel_name: '', //直播频道名称		
    chat_id: '', //聊天室ID
    notice: '', //直播公告
    account_token: '', //主讲人ID
    identity: '', //主讲人身份
    admin_tokens: [], //管理员token列表
    view_count: '', //观看总人数
    comment_count: '', //弹幕总人数
    like_count: '', //点赞总数
    delivery_people_count: '', //投递总人数	
    delivery_count: '', //投递总数
    duration: 0, //直播时长
  },
  // 用户投递职位列表
  liveDelivryList: [],
  // 直播列表职位
  liveDetailJobList: [],
  // 直播列表职位弹窗数据
  showJobTabCardDialogData: {},
  // 直播精品评论
  liveDetailCommentData: {
    page_count: 1,
    total_count: 0,
    comments: []
  },
  
}

export default state
